import Axios from "../../Config/API";
import {
    ICap,
    IFrequenciaVencimento,
    IGetPadraoCobranca,
    IIndiceReajusteParcela,
    IPadraoCobranca,
    IParcelasCustasRequest,
    IPlanoIndexador,
    ITipoDeCustas,
} from "../../../Interfaces/Geral/LancamentoCustas/LancamentoCustasInterface";
import Service from "../../Service";

export async function ListarPlanoIndexadorService(
    empresa: string,
    obra: string,
    venda: string
) {
    return Service(
        Axios.get<Array<IPlanoIndexador>>(
            `/home/lancamentodecusta/listarplanoindexador?empresa=${empresa}&obra=${obra}&venda=${venda}`
        )
    );
}

export async function ListarIndiceReajusteParcelaService() {
    return Service(
        Axios.get<Array<IIndiceReajusteParcela>>(
            `/home/lancamentodecusta/listarindicereajusteparcela`
        )
    );
}

export async function ListarFrequenciaVencimentoService() {
    return Service(
        Axios.get<Array<IFrequenciaVencimento>>(
            `/home/lancamentodecusta/listarfrequenciavencimento`
        )
    );
}

export async function ListarPadraoCobrancaService(empresa: string) {
    return Service(
        Axios.get<Array<IPadraoCobranca>>(
            `/home/lancamentodecusta/listarpadraocobranca?empresa=${empresa}`
        )
    );
}

export async function ListarTiposDeCustasService() {
    return Service(
        Axios.get<Array<ITipoDeCustas>>(
            `/home/lancamentodecusta/listartiposdecustas`
        )
    );
}

export async function ListarCapService() {
    return Service(Axios.get<Array<ICap>>(`/home/lancamentodecusta/listarcap`));
}

export async function CadastrarCustasService(
    idCaso: number,
    idTipoCaso: number,
    filtroParcelasCustas: IParcelasCustasRequest
) {
    return Service(
        Axios.post<string>(
            `/home/lancamentodecusta/cadastrarcustas?idCaso=${idCaso}&idTipoCaso=${idTipoCaso}`,
            filtroParcelasCustas
        )
    );
}

export async function GetPadraoCobrancaService(empresa: string, obra: string) {
    return Service(
        Axios.get<Array<IGetPadraoCobranca>>(
            `/home/lancamentodecusta/getpadraocobranca?empresa=${empresa}&obra=${obra}`
        )
    );
}
